import './wdyr';
import React, { Fragment } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './styles/main.scss';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter } from 'react-router-dom';
import { MuiThemeProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import { ApolloClient, ApolloProvider, InMemoryCache, HttpLink, ApolloLink } from '@apollo/client';
import {setContext} from "@apollo/client/link/context";
import { onError } from '@apollo/client/link/error';
import jobsService from './services/jobs';

jobsService.getSignalRConnection();

import tokenProvider from './utils/token';

import theme from './theme';
import { SnackbarProvider } from 'notistack';
import MainRoutes from './components/Main/MainRoutes';

const httpLink = new HttpLink({
  uri: process.env.REACT_APP_PORTAL_URL + '/graphql',
});

const anansiHttpLink = new HttpLink({
  uri: process.env.REACT_APP_ANANSI_URL + '/graphql',
});

const graphqlEndpoints = ApolloLink.split(
  (operation) => operation.getContext().serviceName === 'anansi',
  anansiHttpLink,
  httpLink
);

const apolloAuthContext = setContext(async (_, {headers}) => {

  const token = tokenProvider.getToken();

  const config = {
    headers: {
        ...headers,
    }
  };

  if (token) {
    config.headers.Authorization = `Bearer ${tokenProvider.getToken()}`
  }

  return config;
})

const client = new ApolloClient({
  link: apolloAuthContext.concat(ApolloLink.from([
    onError(({ graphQLErrors, networkError }) => {
      if (graphQLErrors)
        graphQLErrors.map(({ message, locations, path }) =>
          console.log(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`)
        );
      if (networkError) console.log(`[Network error]: ${networkError}`);
    }),
    graphqlEndpoints,
  ])),
  cache: new InMemoryCache({}),
});

ReactDOM.render(
  <ApolloProvider client={client}>
    <BrowserRouter>
      <MuiThemeProvider theme={theme}>
        <SnackbarProvider maxSnack={3} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
          <Fragment>
            <CssBaseline />
            <MainRoutes />
          </Fragment>
        </SnackbarProvider>
      </MuiThemeProvider>
    </BrowserRouter>
  </ApolloProvider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

export function clearCache() {
  client.cache.reset();
}
